const levels = new Map();

levels.set(1, { duration: 10, foregroundSpeed: 3 });

export default levels;
